module.exports = __webpack_public_path__ + "static/media/drinkIcon.25ffb0ec.svg";